import { SimpleIconButton } from "@/src/components/buttons";
import { Card } from "@/src/components/cards";
import { User } from "@/src/data/allTypes";
import apiFetch from "@/src/utils/apiFetch";
import { getItemId, getUserId, getUserShortName, uid } from "@/src/utils/utils";
import moment from "moment";
import { FaRegStar, FaStar } from "react-icons/fa";
import { Tooltip } from "react-tooltip";

export default function CalendarUserCard({
  isFavourite,
  user,
  isSelected,
  onFavouriteChange,
  onSelect,
  appointmentsCount,
}: {
  isFavourite: boolean;
  isSelected: boolean;
  user: User;
  onFavouriteChange: (user: User) => void;
  onSelect: (user: User) => void;
  appointmentsCount: Record<string, number>;
}) {
  function getTotalAppointmentsCount() {
    let total = 0;
    for (const count of Object.values(appointmentsCount)) {
      total += count;
    }
    return total;
  }

  return (
    <Card
      key={uid()}
      color={isSelected ? "blue" : isFavourite ? "simple" : "simple"}
      title={getUserShortName(user)}
      trailing={
        <SimpleIconButton
          onClick={async () => {
            if (isFavourite) {
              await apiFetch("users", "removeFavouriteCalendar", {
                userId: getUserId(),
                favouriteUserId: getItemId(user),
              });
              onFavouriteChange(user);
            } else {
              await apiFetch("users", "addFavouriteCalendar", {
                userId: getUserId(),
                favouriteUserId: getItemId(user),
              });
              onFavouriteChange(user);
            }
          }}
        >
          {isFavourite ? <FaStar /> : <FaRegStar />}
        </SimpleIconButton>
      }
      onClick={async () => {
        onSelect(user);
      }}
    >
      <div
        style={{ cursor: "pointer", padding: "5px 0px" }}
        data-tooltip-id={`toolTipUserAppointments${getItemId(user)}`}
        data-tooltip-variant="info"
      >
        <Tooltip
          id={`toolTipUserAppointments${getItemId(user)}`}
          place="bottom"
          variant="info"
          content={Object.entries(appointmentsCount)
            .map(([day, count]) => {
              return `${moment(day).format("ddd DD MMM")} ${count} RDV(s)`;
            })
            .join("\n") || "Aucun RDV"}
          style={{
            zIndex: 9999999999,
            maxWidth: "300px",
            background: "RGBA(87, 200, 255,1)",
            color: "black",
            fontSize: "14px",
            boxShadow: "2px 2px 10px RGBA(0,0,0,0.2)",
            padding: "15px",
            borderRadius: "10px",
          }}
        />
        <div className="gray">{getTotalAppointmentsCount()} RDVs</div>
      </div>

    </Card>
  );
}
